import styled, {css} from 'styled-components'
import {Flexbox} from '@/components/ui/flexbox/FlexBox'

export const StyledPageWrapper = styled.div`
    display: grid;
    grid-template-columns: 240px minmax(0, 1fr);
    height: 100%;
    width: 100%;
`

export const StyledPageBody = styled.div`
    display: grid;
    grid-template-rows: 56px auto minmax(0, 1fr);
    overflow: hidden;
`

export const StyledPageHeading = styled(Flexbox)(
    ({theme: {spacing, typography}}) => css`
        padding: ${spacing * 4}px ${spacing * 6}px;
        ${typography.textXl};
        font-weight: 500;
    `
)

export const StyledPageContent = styled.div<{$padding?: number}>(
    ({theme: {spacing}, $padding = 3}) => css`
        padding: ${spacing * $padding}px;
    `
)

export const StyledPageCardWrapper = styled.div(
    ({theme: {palette}}) => css`
        display: grid;
        grid-template-rows: auto auto minmax(0, 1fr);
        background-color: ${palette.neutral['white']};
        height: 100%;
        border-radius: 8px;
        border: 1px solid ${palette.neutral[200]};
        max-width: 1400px;
        margin: auto;
    `
)
